import { jointInvestmentDisplayName, userFullName } from "@equidefi/shared";
import { ENTITY, JOINT, TRUST } from "@equidefi/shared";
import { useMemo } from "react";

import type { DTO } from "@equidefi/shared/types";

type FlatVaultRecord = DTO.Vault & { is_primary?: boolean };

export const useInvestorDisplayName = (
  vault?: { ta_account_type?: string; company?: string; display_name?: string } | null,
  flatVaultRecords?: FlatVaultRecord[],
): string => {
  return useMemo(() => {
    const accountType = vault?.ta_account_type;

    if (accountType === TRUST || accountType === ENTITY) {
      return vault?.company || vault?.display_name || "N/A";
    }

    if (accountType === JOINT && flatVaultRecords?.length) {
      return jointInvestmentDisplayName(flatVaultRecords);
    }

    const primary = flatVaultRecords?.find((r) => r.is_primary);
    if (primary) {
      return userFullName(primary) || vault?.display_name || "N/A";
    }

    return vault?.display_name || "N/A";
  }, [vault, flatVaultRecords]);
};
